const SeniorMechanicMenu = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'senior-mechanic.dashboard'
    },
    class_name: 'mb-3',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Repair Approvals',
    is_heading: true,
    is_active: false,
    link: {
      name: 'senior-mechanic.approvals'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Pending',
    is_heading: false,
    is_active: false,
    link: {
      name: 'senior-mechanic.approvals.pending'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-screwdriver-wrench',
    active_icon: 'fad fa-screwdriver-wrench'
  },
  {
    title: 'Histories',
    is_heading: false,
    is_active: false,
    link: {
      name: 'senior-mechanic.approvals.histories'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-clock-rotate-left',
    active_icon: 'fad fa-clock-rotate-left'
  },
  {
    title: 'Maintenances',
    is_heading: true,
    is_active: false,
    link: {
      name: 'senior-mechanic.maintenances'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Vehicle Categories',
    is_heading: false,
    is_active: false,
    link: {
      name: 'senior-mechanic.maintenances.vehicle-categories'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-car-garage',
    active_icon: 'fad fa-car-garage'
  },
  {
    title: 'Vehicles',
    is_heading: false,
    is_active: false,
    link: {
      name: 'senior-mechanic.maintenances.vehicles'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-car',
    active_icon: 'fad fa-car'
  }
]

export default SeniorMechanicMenu
